export const iconSvg = (id, classes, alt) => `
<span class="icon-svg icon-svg--${id} ${classes ? classes : ''}">
	<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
		<use xlink:href="/img/icons.svg#icon-${id}" x="0" y="0" width="100%" height="100%"></use>
	</svg>
	${alt ? `<span class="u-vhide">${alt}</span>` : ''}
</span>
`;
